"use client";

import { SearchBar } from "@/components/search-bar";
import { useContentData } from "@/lib/use-content-data";

export function HeaderSearch() {
  const { data } = useContentData();

  return (
    <SearchBar
      placeholder="Search..."
      initialData={data}
      className="w-28 lg:w-40"
    />
  );
}
